import { types } from 'mobx-state-tree';

import { PaymentFrequencyEnum } from '../definitions/PaymentFrequency';
import OptionalIdentifier from '../types/OptionalIdentifier';


const Expense = types.model('Expense', {
    id: OptionalIdentifier,
    frequency: types.maybe(PaymentFrequencyEnum),
    type: types.maybe(types.string),
    value: types.maybe(types.number),
});

export default Expense;
